import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { callMethodOnKeydown, screenCssToWorld, isTyping } from '../helpers'
import { viewport } from '../map_state/viewport'
import { pathTracerTool } from './path_tracer_tool'

class EdgeDistanceTool {
  constructor () {
    this.element = document.getElementById('mct-edge-distance')
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.activate = this.activate.bind(this)
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerLeave = this.onPointerLeave.bind(this)
    this.element.addEventListener('click', this.activate)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.activate)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'e' && !this.element.classList.contains('hidden')) callMethodOnKeydown(e.target, this.activate)
  }

  activate (mode = true) {
    if (!state.lenPath) return

    this.active = !state.edgeDistanceMode && mode
    if (this.active) {
      if (state.tracerMode) pathTracerTool.enableMode(state.tracerMode, false)
      this.element.classList.add('selected')
      state.edgeDistanceMode = true
      viewport.element.addEventListener('pointermove', this.onPointerMove)
      viewport.element.addEventListener('pointerleave', this.onPointerLeave)
    } else {
      state.edgeDistanceMode = false
      this.element.classList.remove('selected')
      viewport.element.removeEventListener('pointermove', this.onPointerMove)
      viewport.element.removeEventListener('pointerleave', this.onPointerLeave)
    }

    Renderer.render()
  }

  onPointerMove (e) {
    const rect = viewport.canvas.getBoundingClientRect()
    const world = screenCssToWorld({ x: e.clientX - rect.left, y: e.clientY - rect.top })

    const aabb = {
      left: state.mapWorld.x,
      top: state.mapWorld.y,
      right: state.mapWorld.x + state.mapImage.naturalWidth,
      bottom: state.mapWorld.y + state.mapImage.naturalHeight
    }

    state.cursorWorld = world

    const leftPx = world.x - aabb.left
    const rightPx = aabb.right - world.x
    const topPx = world.y - aabb.top
    const bottomPx = aabb.bottom - world.y

    const inside = world.x >= aabb.left && world.x <= aabb.right && world.y >= aabb.top && world.y <= aabb.bottom

    if (!inside) {
      state.boundaryInfo = {
        left: '--',
        right: '--',
        top: '--',
        bottom: '--',
        inside: false,
        aabb: null
      }
    } else {
      state.boundaryInfo = {
        left: (leftPx * state.lenPath).toFixed(1),
        right: (rightPx * state.lenPath).toFixed(1),
        top: (topPx * state.lenPath).toFixed(1),
        bottom: (bottomPx * state.lenPath).toFixed(1),
        inside: true,
        aabb
      }
    }

    Renderer.render()
  }

  onPointerLeave () {
    state.boundaryInfo = null
    state.cursorWorld = null
  }

  toggleVisibility () {
    this.element.classList.toggle('hidden', !state.calibration)
  }
}

export let edgeDistanceTool = null

export function initEdgeDistanceTool () {
  edgeDistanceTool = new EdgeDistanceTool()
  return edgeDistanceTool
}
